import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { EventClickArg } from "@fullcalendar/react";
import { useState, useCallback, useEffect } from "react";
import {
    ListarAgendamentosController,
    ListarAgendamentosExportarExcelController,
    ListarCompromissoDisponiveisVistoriaAgendaController,
} from "../../Controllers/AssistenciaTecnica/Agendamento/AgendamentoControllers";
import useAsyncCallback from "../../hooks/useAsyncCallback";
import {
    IFiltroListarAgendamento,
    ICompromissosDisponiveis,
    IAgendaCompromisso,
} from "../../Interfaces/AssistenciaTecnica/Agendamento/AgendamentoInterfaces";
import DescricaoEventoAgendamento from "../../Pages/AssistenciaTecnica/AgendaAssistenciaTecnica/DescricaoEventoAgendamento";
import { FilterAgendaAssistenciaTecnica } from "../../Pages/AssistenciaTecnica/AgendaAssistenciaTecnica/FilterAgendaAssistenciaTecnica";
import ModalComponent from "../Modais";
import { IComponentModal } from "../Modais/IModalComponent";
import StickyToolbar from "../StickyToolbar";
import AgendaComponent from "./AgendaComponent";
import { ICompromissoDisponivelVistoria } from "../../Interfaces/VistoriaEntregaChaves/CompromissoDisponivel/CompromissoDisponivelInterfaces";
import DescricaoEventoDisponivelVistoria from "../../Pages/AssistenciaTecnica/AgendaAssistenciaTecnica/DescricaoEventoCompromissoDisponivelVistoria";
import moment from "moment";
import { useUserInfor } from "../../Context/User";
import { AlertConfirmation } from "../../Tools/SweetAlerts";
import { useHistory } from "react-router-dom";
import ExportExcel from "../StickyToolbar/ExportExcel";
import { useForm } from "react-hook-form";

interface IFiltrosDeAgendamento extends IFiltroListarAgendamento {}
interface IFiltroDeData
    extends Pick<IFiltroListarAgendamento, "DT_INICIO" | "DT_FIM"> {}

const filtroInicial: IFiltrosDeAgendamento = {
    FL_FILTRAR_VENCIDAS: false,
    ID_COMPROMISSO: 0,
    ID_PRODUTO: 0,
    ID_USUARIO: 0,
    ID_TIPO_CASO: 0,
    ID_TIPO_COMPROMISSO: 0,
    ID_GRUPO: 0,
    DT_FIM: new Date(),
    DT_INICIO: new Date(),
    FL_APENAS_MEUS_AGENDAMENTOS: false,
};

interface IAgendaComponentProps {
    mostrarFiltro?: boolean;
    flApenasAgendamentosDoUsuario?: boolean;
    responsivo?: boolean;
}

export default function Agenda(props: IAgendaComponentProps) {
    const {
        ListarEventos,
        eventClick,
        modal,
        setFiltroListarAgendamento,
        filtroListarAgendamento,
        setShow,
        show,
        listarAgendamentos,
        setAtualizaAgenda,
        setTipoAgendamento,
        dateRange,
    } = useMetadata(props.flApenasAgendamentosDoUsuario);

    const filtroInicial: Omit<
        IFiltrosDeAgendamento,
        "DT_FIM" | "DT_INICIO" | "FL_APENAS_MEUS_AGENDAMENTOS"
    > = {
        FL_FILTRAR_VENCIDAS: false,
        ID_COMPROMISSO: 0,
        ID_PRODUTO: 0,
        ID_USUARIO: 0,
        ID_TIPO_CASO: 0,
        ID_TIPO_COMPROMISSO: 0,
        ID_GRUPO: 0,
    };

    const { FUNCOES, GRUPOS } = useUserInfor().UserInfor;
    const mostrarAgendaGrupo = FUNCOES.some(
        (f) => f.NM_FUNCAO === "ADM_VISUALIZAR_AGENDA_GRUPO"
    );

    const FormMethods = useForm();
    const { reset, getValues } = FormMethods;

    return (
        <>
            {mostrarAgendaGrupo && (
                <div
                    className={"d-flex justify-content-end align-items-center"}
                >
                    <label>Filtro de Grupo:</label>
                    <select
                        className={`form-control placeholder-dark-50 w-25 ml-2`}
                        name="ID_GRUPO"
                        onChange={(e) => {
                            setFiltroListarAgendamento({
                                ...filtroListarAgendamento,
                                ID_GRUPO: Number(Number(e.target.value)),
                            });
                        }}
                    >
                        <option value="0">
                            Selecione um grupo para filtrar...
                        </option>
                        {GRUPOS.map((grupo, index) => {
                            return (
                                <option value={grupo.ID_GRUPO}>
                                    {grupo.DS_GRUPO}
                                </option>
                            );
                        })}
                    </select>
                </div>
            )}

            {props.mostrarFiltro && (
                <StickyToolbar>
                    <FilterAgendaAssistenciaTecnica
                        handleFilterFormSubmit={setFiltroListarAgendamento}
                        setTipoAgendamento={setTipoAgendamento}
                        filtroInicial={filtroInicial}
                        FormMethods={FormMethods}
                        reset={reset}
                        getValues={getValues}
                        dateRange={dateRange}
                    />
                </StickyToolbar>
            )}

            <ExportExcel
                baixarExcelController={async () =>
                    ListarAgendamentosExportarExcelController(
                        {
                            ...filtroListarAgendamento,
                            DT_INICIO: dateRange.start
                                ? dateRange.start
                                : filtroListarAgendamento.DT_INICIO,
                            DT_FIM: dateRange.end
                                ? dateRange.end
                                : filtroListarAgendamento.DT_FIM,
                            FL_APENAS_MEUS_AGENDAMENTOS:
                                filtroListarAgendamento.FL_APENAS_MEUS_AGENDAMENTOS ??
                                false,
                        },
                        true
                    )
                }
                nomeArquivo={"Atendimentos_Assistência_Técnica"}
            />

            <div className={"w-100 h-100 "}>
                <AgendaComponent
                    events={ListarEventos}
                    listarAgendamentos={listarAgendamentos}
                    eventClick={eventClick}
                    responsivo={props.responsivo}
                    filtroListarAgendamento={filtroListarAgendamento}
                    setAtualizaAgenda={setAtualizaAgenda}
                />
            </div>
            <ModalComponent
                ModalComponent={modal}
                show={show}
                setShow={setShow}
            />
        </>
    );
}

// hook que concentra lógica
function useMetadata(FL_APENAS_MEUS_AGENDAMENTOS?: boolean) {
    const [atualizaAgenda, setAtualizaAgenda] = useState(false);

    const [filtroListarAgendamento, setFiltroListarAgendamento] =
        useState<IFiltrosDeAgendamento>(filtroInicial);

    const [tipoAgendamento, setTipoAgendamento] = useState<string>();

    const [dateRange, setDateRange] = useState<{
        start: Date;
        end: Date;
    }>({
        start: new Date(),
        end: new Date(),
    });

    const history = useHistory();

    const lstEtapasTipoCaso = [
        {
            nrEtapa: 1,
            color: "red",
        },
        {
            nrEtapa: 2,
            color: "red",
        },
        {
            nrEtapa: 3,
            color: "red",
        },
        {
            nrEtapa: 4,
            color: "black",
        },
        {
            nrEtapa: 5,
            color: "yellow",
        },
        {
            nrEtapa: 6,
            color: "blue",
        },
        {
            nrEtapa: 7,
            color: "purple",
        },
        {
            nrEtapa: 10,
            color: "green",
        },
    ];

    const { value: lstAgendamentos, execute: listarAgendamentos } =
        useAsyncCallback(
            async (filtrosDeData: IFiltroDeData) => {
                // if (lstAgendamentosMapCacheRef.current.has(cacheKey))
                //     return lstAgendamentosMapCacheRef.current.get(cacheKey)!;
                // else {
                const lstAgendamentos: IAgendaCompromisso[] = [];
                await ListarAgendamentosController({
                    ...filtroListarAgendamento,
                    ...filtrosDeData,
                    FL_APENAS_MEUS_AGENDAMENTOS:
                        FL_APENAS_MEUS_AGENDAMENTOS ?? false,
                }).then((res) => {
                    return res.map((v) => {
                        return v.COMPROMISSOS.map((value) => {
                            return lstAgendamentos.push(value);
                        });
                    });
                });
                // lstAgendamentosMapCacheRef.current.set(
                //     cacheKey,
                //     lstAgendamentos
                // );
                return lstAgendamentos;
            },
            [filtroListarAgendamento, setFiltroListarAgendamento]
        );

    const {
        value: lstCompromissosDisponiveis,
        execute: listarCompromissosDisponiveis,
    } = useAsyncCallback(
        async (filtrosDeData: ICompromissoDisponivelVistoria) => {
            const lstCompromissosDisponiveis: ICompromissosDisponiveis[] = [];

            await ListarCompromissoDisponiveisVistoriaAgendaController(
                filtrosDeData.DT_INICIO,
                filtrosDeData.DT_FIM ?? "",
                filtrosDeData.ID_TIPO_COMPROMISSO
                    ? filtrosDeData.ID_TIPO_COMPROMISSO
                    : filtroListarAgendamento.ID_TIPO_COMPROMISSO ?? 0,
                filtroListarAgendamento.ID_PRODUTO,
                filtroListarAgendamento.ID_USUARIO,
                10
            ).then((res) => {
                return res.map((v) => {
                    return v.COMPROMISSOS.map((value) => {
                        return lstCompromissosDisponiveis.push(value);
                    });
                });
            });
            // lstCompromissosDisponveisMapCacheRef.current.set(
            //     cacheKey,
            //     lstCompromissosDisponiveis
            // );
            return lstCompromissosDisponiveis;
        },
        [filtroListarAgendamento, setFiltroListarAgendamento]
    );

    useEffect(() => {
        const agora = new Date();
        const compromissosHoje = lstAgendamentos?.filter((compromisso) => {
            const dtInicio = new Date(compromisso.DT_INICIO);
            return (
                agora.getDate() === dtInicio.getDate() &&
                agora.getMonth() === dtInicio.getMonth() &&
                agora.getFullYear() === dtInicio.getFullYear() &&
                agora.getTime() < dtInicio.getTime()
            );
        });

        const alertaExibidoAnteriormente =
            sessionStorage.getItem("alertaExibido");

        if (
            compromissosHoje &&
            compromissosHoje.length > 0 &&
            !Boolean(alertaExibidoAnteriormente)
        ) {
            sessionStorage.setItem("alertaExibido", "true");
            const primeiroCompromisso = compromissosHoje[0];

            AlertConfirmation(
                `Você tem um compromisso hoje das  ${moment(
                    primeiroCompromisso.DT_INICIO
                ).format("HH:mm")} às ${moment(
                    primeiroCompromisso.DT_FIM
                ).format("HH:mm")}`,
                `Compromisso: ${primeiroCompromisso.DS_TIPO_COMPROMISSO}`,
                "info",
                {
                    confirmButtonText: "Verificar compromisso",
                    cancelButtonText: "Fechar",
                }
            ).then((result) => {
                if (result.isConfirmed) {
                    const arg: any = {
                        el: null,
                        event: {
                            id: primeiroCompromisso.ID_COMPROMISSO.toString(),
                        },
                        jsEvent: null,
                        view: null,
                    };

                    history.push("/Geral/Agenda");
                    setTimeout(() => {
                        eventClick(arg);
                    }, 1000);
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lstAgendamentos, history]);

    const ListarEventos = useCallback(
        (eventInfo, successCallback, errorCallback) => {
            setDateRange({
                start: eventInfo.start,
                end: eventInfo.end,
            });
            if (tipoAgendamento === "Horários Disponíveis") {
                listarCompromissosDisponiveis({
                    DT_INICIO: eventInfo.start.toISOString(),
                    DT_FIM: eventInfo.end.toISOString(),
                    FL_ATIVO: eventInfo.FL_ATIVO,
                    ID_COMPROMISSO_DISPONIVEL_VISTORIA:
                        eventInfo.ID_COMPROMISSO_DISPONIVEL_VISTORIA,
                    ID_PRODUTO: filtroListarAgendamento.ID_PRODUTO,
                    idsHorarios: eventInfo.idsHorarios,
                    ID_USUARIO: filtroListarAgendamento.ID_USUARIO,
                }).then((res) => {
                    setAtualizaAgenda(false);
                    successCallback(
                        lstCompromissosDisponiveis?.map(
                            (value: ICompromissosDisponiveis) => ({
                                title: `Horário disponível: 
                                              ${moment(value?.DT_INICIO).format(
                                                  "HH:mm"
                                              )} -
                                              ${moment(value?.DT_FIM).format(
                                                  "HH:mm"
                                              )}`,
                                id: value.ID_COMPROMISSO_DISPONIVEL_VISTORIA?.toString(),
                                start: new Date(value.DT_INICIO),
                                end: new Date(value.DT_FIM ?? ""),
                                atualizaAgenda: atualizaAgenda,
                            })
                        )
                    );
                });
            } else if (tipoAgendamento === "Horários Agendados") {
                listarAgendamentos({
                    DT_INICIO: eventInfo.start,
                    DT_FIM: eventInfo.end,
                }).then((res) => {
                    setAtualizaAgenda(false);
                    successCallback(
                        res.map((compromisso) => ({
                            title: `${compromisso.DS_ASSUNTO} - ${compromisso.DS_TIPO_COMPROMISSO}`,
                            id: compromisso.ID_COMPROMISSO.toString(),
                            start: new Date(compromisso.DT_INICIO),
                            end: new Date(compromisso.DT_FIM),
                            atualizaAgenda: atualizaAgenda,
                            color:
                                lstEtapasTipoCaso?.find(
                                    (etapaItem) =>
                                        etapaItem.nrEtapa ===
                                        compromisso.NR_ETAPA
                                )?.color ?? "black",
                        }))
                    );
                });
            } else {
                listarAgendamentos({
                    DT_INICIO: eventInfo.start,
                    DT_FIM: eventInfo.end,
                })
                    .then((resEvent) => {
                        listarCompromissosDisponiveis({
                            DT_INICIO: eventInfo.start.toISOString(),
                            DT_FIM: eventInfo.end.toISOString(),
                            FL_ATIVO: eventInfo.FL_ATIVO,
                            ID_COMPROMISSO_DISPONIVEL_VISTORIA:
                                eventInfo.ID_COMPROMISSO_DISPONIVEL_VISTORIA,
                            ID_PRODUTO: filtroListarAgendamento.ID_PRODUTO,
                            idsHorarios: eventInfo.idsHorarios,
                            ID_USUARIO: filtroListarAgendamento.ID_USUARIO,
                        })
                            .then((res: any) => {
                                setAtualizaAgenda(false);
                                // res = [];
                                const concatArray = resEvent.concat(res);
                                successCallback(
                                    concatArray.map((value: any) =>
                                        value.ID_COMPROMISSO_DISPONIVEL_VISTORIA
                                            ? {
                                                  title: `Horario Disponivel
                                                  ${moment(
                                                      value?.DT_INICIO
                                                  ).format("HH:mm")} -
                                                  ${moment(
                                                      value?.DT_FIM
                                                  ).format("HH:mm")} -
                                                  ${value.DS_PRODUTO} 
                                                  `,
                                                  id: value.ID_COMPROMISSO_DISPONIVEL_VISTORIA?.toString(),
                                                  start: new Date(
                                                      value.DT_INICIO
                                                  ),
                                                  end: new Date(
                                                      value.DT_FIM ?? ""
                                                  ),
                                                  atualizaAgenda:
                                                      atualizaAgenda,
                                              }
                                            : {
                                                  title: `${
                                                      value.DS_EMPREENDIMENTO
                                                          ? value.DS_EMPREENDIMENTO
                                                          : value.DS_ASSUNTO
                                                  } `,
                                                  id: value.ID_COMPROMISSO.toString(),
                                                  start: new Date(
                                                      value.DT_INICIO
                                                  ),
                                                  end: new Date(value.DT_FIM),
                                                  atualizaAgenda:
                                                      atualizaAgenda,
                                                  color:
                                                      lstEtapasTipoCaso?.find(
                                                          (etapaItem) =>
                                                              etapaItem.nrEtapa ===
                                                              value.NR_ETAPA
                                                      )?.color ?? "black",
                                              }
                                    )
                                );
                            })
                            .catch((err) => {
                                errorCallback({
                                    message: err.message,
                                });
                            });
                    })
                    .catch((err) => {
                        errorCallback({
                            message: err.message,
                        });
                    });
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            listarAgendamentos,
            atualizaAgenda,
            filtroListarAgendamento,
            listarCompromissosDisponiveis,
        ]
    );

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    function eventClick(arg: EventClickArg) {
        const agendamento = lstAgendamentos?.find(
            (a) => a.ID_COMPROMISSO === Number(arg.event.id)
        );

        if (agendamento) {
            setModal({
                Children: (
                    <DescricaoEventoAgendamento
                        agendamento={agendamento}
                        setShow={setShow}
                        setAtualizaAgenda={setAtualizaAgenda}
                    />
                ),
                IconHeader: faCalendar,
                headerComponent: "Evento",
                noHeader: true,
                noFooter: true,
            });
            setShow(true);
        }

        const compromissos = lstCompromissosDisponiveis?.find(
            (c) => c.ID_COMPROMISSO_DISPONIVEL_VISTORIA === Number(arg.event.id)
        );

        if (compromissos) {
            setModal({
                Children: (
                    <DescricaoEventoDisponivelVistoria
                        compromissos={compromissos}
                    />
                ),
                IconHeader: faCalendar,
                noHeader: true,
                noFooter: true,
            });
            setShow(true);
        }
    }

    return {
        setFiltroListarAgendamento,
        show,
        modal,
        setShow,
        listarAgendamentos,
        ListarEventos,
        filtroListarAgendamento,
        eventClick,
        listarCompromissosDisponiveis,
        setAtualizaAgenda,
        setTipoAgendamento,
        dateRange,
    };
}
